import { defineMessages, useIntl } from "react-intl";

import {
  MutationActions,
  QueryKeys,
  queryClient,
  useEntityMutation,
} from "@/api/core";
import { CarouselGroupKeys } from "@/api/hooks/carousels/useCarouselGroups";
import { useApi } from "@/hooks";
import { groupRelationshipSchema } from "@/schemas";
import toast from "@/toast";

const messages = defineMessages({
  unmuteSuccess: {
    id: "feed.edit.group_unmute_success",
    defaultMessage: "Unmuted the group",
  },
});

interface Variables {
  id: string;
}

function useUnmuteGroup() {
  const api = useApi();
  const intl = useIntl();

  return useEntityMutation({
    globalQueryKey: QueryKeys.groupRelationships.global,
    action: MutationActions.UPDATE,
    schema: groupRelationshipSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/groups/${variables.id}/unmute`),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: CarouselGroupKeys.groups });
      toast.success(intl.formatMessage(messages.unmuteSuccess));
    },
  });
}

export { useUnmuteGroup };
